import classNames from 'classnames';
import { Box } from '@stitch-fix/mode-react';
import { CloudinaryImageFields } from '../CloudinaryImageWrapper';
import { MediaItem } from './MediaItem';
import styles from './styles.module.scss';
import { ContentItem } from './ContentItem';
import { useStickyCtaContext } from '../StickyCta/useStickyCtaContext';
import { ModularComponentProps } from '../ModularPageWrapper/ModularPageWrapper';
import { useAutoAdvanceTimer } from './useAutoAdvanceTimer';

type GalleryHeroItem = {
  minorTitle: string;
  majorTitle: string;
  cta: {
    text: string;
    url: string;
  };
  media?: {
    mobile: CloudinaryImageFields;
    desktop: CloudinaryImageFields;
  };
  CtaButton?: React.ReactNode;
};

export type GalleryHeroProps = {
  items: GalleryHeroItem[];
  layout?: 'full' | 'split';
  buttonColor?: string;
};

export const GalleryHero = ({
  layout = 'full',
  items,
  buttonColor,
  verticalSpacing,
}: GalleryHeroProps & ModularComponentProps) => {
  const { setStickyContainerTarget } = useStickyCtaContext();
  const { activeSlideIndex, shouldAnimate } = useAutoAdvanceTimer({
    totalItems: items.length,
  });

  return (
    <Box bgColor="gray-99" mt={verticalSpacing}>
      <Box
        ref={setStickyContainerTarget}
        className={classNames(styles.container, {
          [styles.splitView]: layout === 'split',
        })}
      >
        <Box className={styles.media}>
          {items.map((item, index) => (
            <MediaItem
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              slideIndex={index}
              activeSlideIndex={activeSlideIndex}
              items={items}
              initialAnimate={shouldAnimate}
            />
          ))}
        </Box>
        <Box className={styles.content}>
          <ContentItem
            slideIndex={activeSlideIndex}
            items={items}
            buttonColor={buttonColor}
          />
        </Box>
      </Box>
    </Box>
  );
};
